
import request from '@/utils/request';

const baseURLAdmin = process.env.VUE_APP_ADMIN;

// POD 不合格类型关键词配置————分页查询
export const podInvalidKeywordPage = (data) => {
  return request({
    method: 'post',
    url: '/pod-invalid-keyword/page',
    data,
    baseURL: baseURLAdmin
  });
};

// POD 不合格类型关键词配置————新增或修改（id 为空即新增）
export const podInvalidKeywordSave = (data) => {
  return request({
    method: 'post',
    url: '/pod-invalid-keyword/save',
    data,
    baseURL: baseURLAdmin
  });
};

// POD 不合格类型关键词配置————启用 / 停用
export const podInvalidKeywordChangeStatus = (data) => {
  return request({
    method: 'post',
    url: '/pod-invalid-keyword/changeStatus',
    data,
    baseURL: baseURLAdmin
  });
};

// POD 不合格类型关键词配置————删除
export const podInvalidKeywordDelete = (id) => {
  return request({
    method: 'post',
    url: `/pod-invalid-keyword/delete/${id}`,
    baseURL: baseURLAdmin
  });
};
